import React, { useEffect, useState } from "react";
import { renderStepContent } from "./renderStepContent";
import { StepperProvider, useStepperContext } from "./StepperContext";
import PageLayout from "../../pages/PageLayout";
import VerticalLinearStepper from "./Stepper";
import PageTitle from "../../components/pageTitle";

export const steps = [
  {
    label: "Please Enter Partner ID",
    actionCompleted: false,
    expanded: true,
  },
  {
    label: "Type of Payment",
    actionCompleted: false,
    expanded: true,
  },
  {
    label: "Payment Details",
    actionCompleted: false,
    expanded: true,
  },
  {
    label: "Success/Failure",
    actionCompleted: false,
    expanded: true,
  },
];

const stepCompletionActions = [
  (steps, setSteps) => {
    const updatedSteps = [...steps];
    updatedSteps[0].actionCompleted = true;
    setSteps(updatedSteps);
  },
  (steps, setSteps) => {
    const updatedSteps = [...steps];
    updatedSteps[1].actionCompleted = true;
    setSteps(updatedSteps);
  },
  (steps, setSteps) => {
    const updatedSteps = [...steps];
    updatedSteps[2].actionCompleted = true;
    setSteps(updatedSteps);
  },
];

const InitiateCashCollection = () => {
  return (
    <StepperProvider initialSteps={steps}>
      <PageTitle title="Cash Collection" />
      <VerticalLinearStepper
        renderStepContent={renderStepContent}
        useStepperContext={useStepperContext}
        onStepCompletion={stepCompletionActions}
      />
    </StepperProvider>
  );
};

export default InitiateCashCollection;
